import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Select from "componentsReusable/Select";
import useAfterUpdateEffect from "utils/useAfterUpdateEffect";
import useDidMountEffect from "utils/useDidMountEffect";
import AppSelect from "../../../../../componentsReusable/AppSelect";

const PartSetQualColsSelect = props => {
  const [value, setValue] = useState(props.value)

  useDidMountEffect(() => {
    if(props.partSetQualCols.length === 1){
      setValue(props.partSetQualCols[0].PartQualColId)
    }
  })

  useAfterUpdateEffect(() => {
    props.onChange(value)
  }, [value])

  const options = props.partSetQualCols.map(partSetQualCol => ({
    ...partSetQualCol,
    id: partSetQualCol.PartQualColId,
  }))

  return <AppSelect
    isClearable={false}
    isSearchable={false}
    options={options}
    getLabelFn={partSetQualCol => partSetQualCol.PartQualColText}
    onChange={({id}) => setValue(id)}
    value={options.find(option => option.id === value)}
  />
};

PartSetQualColsSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  partSetQualCols: PropTypes.arrayOf(PropTypes.shape({

  }).isRequired,).isRequired,
};

export default PartSetQualColsSelect;